<div id="modalDialog" class="confirm-dialog-body" role="alertdialog" cdkFocusInitial mat-dialog-container aria-labelledby="modalTitle">
    <div id="modalTitle"  mat-dialog-title class="cnfrmtnDlgHdr" cdkFocusInitial tabindex="0" attr.aria-label="{{title}}">
      <span class="title-txt title-txt-fix">{{title}}</span>
      <div (click)="onCancelClick()" class="close-btn-section">
        <mat-icon aria-hidden="false" class="close-icon" aria-label="close icon">cancel</mat-icon>
        <div class="close-txt">CLOSE</div>
      </div>
    </div>
    <div class="cnfrmtnDlgCntnt" tabindex="0" attr.aria-label="{{message}}">{{message}}</div>
    <div class="div-yes-no">
      <div class="innerDivActnBtns" >
        <button mat-stroked-button class="button continue-btn" (click)="onSubmitClick()">{{button1Text}}</button>
      </div>
    </div>
  </div>
  